import { Outlet } from 'react-router-dom';
import * as sharedComponents from '../' 
import { useEffect, useState } from 'react';
import { INavbarPage } from '../../models/navbar_models';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';


const MainLayout = () => {

    const [navPages, setNavPages] = useState<Array<INavbarPage>>([])
    const appSlice = useSelector((state:RootState) => state.app)

      useEffect(() => {
        const navBarPages = []
        if(appSlice.appFeatureConfigs?.chat.has_access)
          navBarPages.push({url: "ai-search", title: "AI Search"})
    
        setNavPages(navBarPages)
      }, [appSlice.appFeatureConfigs])
    
    return (
        <>
            <sharedComponents.Navbar 
                name={appSlice.appFeatureConfigs?.app_name} 
                pages={navPages}
            />
                <Outlet />
            <sharedComponents.Footer />
        </>
    )
}

export default MainLayout